<div class="wrapper">
    <h1 class="header">{{ "SHARED.SELECT_VENDOR" | translate }}:</h1>

    <ion-list *ngIf="loading" lines="none">
        <ion-item>
            <ion-label>
                <p>
                    <ion-skeleton-text [animated]="true" style="width: 100%"></ion-skeleton-text>
                </p>
                <p>
                    <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
                </p>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-list *ngIf="!loading" lines="none">
        <ion-item *ngIf="vendors.length >= 15">
            <ion-searchbar
                [(ngModel)]="searchParam"
                [debounce]="200"
                (ionInput)="filterVendors()"
                placeholder="{{ 'SHARED.SEARCH' | translate }}"
            ></ion-searchbar>
        </ion-item>
        <ion-item *ngIf="selectedVendor" (click)="selectVendor()" button="true" detail="false">
            <div class="vendor-item">
                <ion-checkbox class="vendor-checkbox"></ion-checkbox>
                <ion-label>{{ "SHARED.ALL_VENDORS" | translate }}</ion-label>
            </div>
        </ion-item>
        <ion-item
            *ngFor="let vendor of vendors"
            button="true"
            detail="false"
            (click)="selectVendor(vendor.id)"
        >
            <div class="vendor-item">
                <ion-checkbox
                    [checked]="vendor.id === selectedVendor"
                    class="vendor-checkbox"
                ></ion-checkbox>
                <img *ngIf="vendor.imageUrl" [src]="vendor.imageUrl" class="vendor-logo" />
                <ion-label>{{ vendor.name }}</ion-label>
            </div>
        </ion-item>
        <ion-item *ngIf="vendors.length === 0" class="txt-center">
            <ion-label>
                <p>{{ "SHARED.NO_VENDORS_FOUND" | translate }}</p>
            </ion-label>
        </ion-item>
    </ion-list>
</div>
